// Open Color
// https://yeun.github.io/open-color/

export const GRAY_0 = "#f8f9fa";
export const GRAY_1 = "#f1f3f5";
export const GRAY_2 = "#e9ecef";
export const GRAY_3 = "#dee2e6";
export const GRAY_4 = "#ced4da";
export const GRAY_5 = "#adb5bd";
export const GRAY_6 = "#868e96";
export const GRAY_7 = "#495057";
export const GRAY_8 = "#343a40";
export const GRAY_9 = "#212529";

export const RED_6 = "#fa5252";
export const RED_7 = "#f03e3e";
export const RED_8 = "#e03131";
export const RED_9 = "#c92a2a";

export const BLUE_4 = "#4dabf7";
export const BLUE_5 = "#339af0";
export const BLUE_6 = "#228be6";
export const BLUE_7 = "#1c7ed6";
export const BLUE_8 = "#1971c2";
export const BLUE_9 = "#1864ab";

export const ORANGE_9 = "#d9480f";

export const LIME_9 = "#5c940d";

export const GRAPE_9 = "#862e9c";
